module.exports = __webpack_public_path__ + "static/media/cases_3d_06a.7985ead1.jpg";